module.exports = __webpack_public_path__ + "img/diversion_bg.0b774109.jpeg";